export enum ClientHealthSummaryTypeEnum {
  Allergy = "allergies",
  BloodType = "blood type",
  Problem = "problems",
  Medication = "medications",
}
